import React, {forwardRef, useImperativeHandle, useState, useRef, useEffect} from 'react'
import {Modal, DatePicker, Select, message, Input, Button} from 'antd'
import './index_mic.scss';//鉴于iop样式要根据主题色进行变化，其他系统样式固定
import moment from "moment";
import Tools from '../tools/Tools'
import InstructTypeSelect from './InstructTypeSelect'
import BatchCarSelect from "./BatchCarSelect";
import WWInput from "./antdReset/WWInput";
import WWTable from "./Table";
let formatTime = 'YYYY-MM-DD HH:mm:ss'
import ExportFileInstruct from './ExportFileInstruct'
const Option = Select.Option;
let repeatObj = {
    1:365,
    2:52,
    3:12
}
let repeatDescObj = {
    1:Strings.rs14391,
    2:Strings.rs14392,
    3:Strings.rs14393
}
function AddBatchInstructModalMic(props, ref) {
    const [addMicInstructVisible, setAddMicInstructVisible] = useState(false)
    const [name, setName] = useState('')
    const [time, setTime] = useState('')
    const [deadlineTime,setDeadlineTime] = useState('');
    const [rules, setRules] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [deviceCount, setDeviceCount] = useState(0)
    const [password, setPassword] = useState('')
    const [format, setFormat] = useState('')
    const [count, setCount] = useState('')
    const [routine, setRoutine] = useState("")
    const [id, setId] = useState('')
    const [status, setStatus] = useState('')
    const [repeatCount, setRepeatCount] = useState(1)
    const [isAdd, setIsAdd] = useState(true)
    const micSelect = useRef(null)
    const [sendType,setSendType] = useState("")
    const [emails,setEmails] = useState([""])
    const [errorList_visible,setErrorList_visible] = useState(false);
    const [errorList,setErrorList] = useState([])
    useImperativeHandle(ref, () => ({
        showModal: (id,detailId) => {
            setAddMicInstructVisible(true)
            if(id) {
                setId(id)
                setIsAdd(false)
                getDetail(id);
            } else {
                setIsAdd(true)
            }
        }
    }))
    //指令详情
    function getDetail(id) {
        let url = `${Tools.getApiUrl("taskDetail",props.platform)}${id}`
        Tools.fetch(url,'GET',function (data) {
            if (data.code === 0){
                let instructObj = data.data || {}
                setName(instructObj.name)
                let routine_temp = instructObj.hasOwnProperty("routine")?instructObj.routine.toString():""
                setRoutine(routine_temp)
                setRules(instructObj.rules)
                setCount(instructObj.count)
                setFormat(instructObj.format)
                setStatus(instructObj.status)
                setTime(instructObj.time?moment(instructObj.time*1000):'')
                let imeis = []
                instructObj.deviceSimpleBeans.map(function (item) {
                    imeis.push(item.imei)
                })
                let sendType_temp = instructObj.hasOwnProperty("sendType")?instructObj.sendType.toString():""
                setSendType(sendType_temp);
                setDeadlineTime(instructObj.deadlineTime?moment(instructObj.deadlineTime*1000):'')
                setEmails(instructObj.emails?instructObj.emails:[""])
                micSelect.current.setSelectedDeviceList(imeis)
                micSelect.current.isDetail()

                getDeviceList(currentPage,isTakeSub,props.accountId)
            } else {
                message.error(data.message)
            }
        })
    }

    //隐藏弹框
    function hideModal() {
        setName('')
        setRoutine('')
        setRules(0)
        setCount('')
        setFormat('')
        setTime('')
        setPassword('')
        setSendType('')
        setDeadlineTime('')
        setEmails([""])
        micSelect && micSelect.current && micSelect.current.reset()
        setErrorList_visible(false)
        setAddMicInstructVisible(false)

    }
    //确认保存
    function handleOk() {
        let selectedDeviceList = micSelect.current.getSelectedDeviceList()
        let url = Tools.getApiUrl("addModifyTask",props.platform);
        if(!selectedDeviceList.length) {
            message.error(Strings.rs10424)
            return
        }
        if(Tools.isNull(routine)) {
            message.error(Strings.rs14358 || Strings.select5)
            return
        }
        if(Tools.isDeviceMgt(props.platform) && Tools.isNull(password)) {
            message.error(Strings.rs10396 || Strings.inputPassword)
            return
        }
        if (repeatCount && rules && !count){
            message.error(Strings.rs14369)
            return
        }
        if (Tools.isNull(sendType)){
            message.error(Strings.sendtypeTips)
            return
        }
        if(sendType && sendType === "1" && Tools.isNull(deadlineTime)){
            message.error(Strings.deadlineTime)
            return
        }
        let model = {
            name,format,rules,time:moment(time).unix(),zoneId:Tools.getZoneName(),
            count,routine,
            devices: selectedDeviceList
        }
        if(Tools.isDeviceMgt(props.platform)) {
            model.password = hex_md5(password);
        }else{
            model.sendType = sendType;
            model.emails = emails;
            model.deadlineTime = moment(deadlineTime).unix()
        }
        if (!isAdd) {
            model.id = id
        }
        Tools.fetch(url,isAdd?'POST':'PUT',model,function (data) {
            if (data.code === 0) {
                message.success(Strings.rs10411 || Strings.rs10360)
                if(data.data){
                    //bizName,imei;
                    setErrorList(data.data);
                    setErrorList_visible(true);
                }
                props.refresh&&props.refresh()
                hideModal()

            } else {
                message.error(data.message)
            }
        })
    }
    //获取设备列表
    function getDeviceList(current,takeSub,id) {
        micSelect.current.getDeviceList(current,takeSub,id)

    }
    //获取emails展示组件
    const emailItems = ()=>{
        return emails.map((item,index) =>{
            return <div className="modal_item ">
                <span className="form_span">{Strings.mailsInstruct}{index+1}</span>
                <div className={"form_value"}>
                    <WWInput className="w200" value={item} onChange={(e)=>{setValue(e,index)}} disabled={!isAdd}></WWInput>
                    {emails.length < 3 && isAdd ?<i className="icon blue iconfont icon-tianjia mgl15" onClick={()=>{addDelItem()}}></i>:null}
                    {emails.length === 1 ?null:isAdd?<i className="icon red iconfont icon-shanchu mgl5" onClick={()=>addDelItem(index,"del")}></i>:null}
                </div>
            </div>
        })
    }
    //email组件更新数据
    const setValue = (value,index)=>{
        let temp = Array.from(emails,(x,curIndex)=>{
            let temp_x = x;
            if(curIndex === index){
                temp_x=value;
            }
            return temp_x;
        })
        setEmails(temp);
    }
    //email组件删除操作
    const addDelItem = (index,type)=>{
        let temp_arr = Array.from(emails);
        if(type === "del"){
            temp_arr.splice(index,1);
        }else{
            temp_arr.push("");
        }

        setEmails(temp_arr);
    }
    //点击保存后，不支持的设备清单列
    const error_columns = [
        {
            title: Strings.carCode,
            dataIndex: 'bizName',
            width: '50%'
        }, {
            title: Strings.rs10084,
            dataIndex: 'imei',
            width: '50%'
        },
    ]
    //


    return <Modal transitionName="" maskTransitionName=""
                  className="default_modal wid1000 mic_model"
                  width=""
                  destroyOnClose={true}
                  visible={addMicInstructVisible}
                  onCancel={hideModal}
                  maskClosable={false}
                  title={isAdd ?Strings.addInstructTitle :Strings.instructDetailTitle}
                  footer={null}>
                    <div className="maps-api-tip">
                        <i className='icon-zhushi iconfont' style={{color: 'var(--BG-C)', fontSize: 16}}/>
                        <div className="mgl17">
                            <div>{Strings.rs14359}</div>
                        </div>
                    </div>
                    <div className="batch_instruct_content">
                        <BatchCarSelect ref={micSelect} {...props}/>
                        <div className="instruct_content">
                            <div className={"commonTitle"}><label>{Strings.instructRule}</label></div>
                            <div className={"modal_item"}>
                                <span className="form_span">{Strings.rs10836 || Strings.taskname}</span>
                                <div className={"form_value"}>
                                    <Input value={name} placeholder={Strings.rs10846} maxLength={50}
                                           onChange={(e) => setName(e.target.value.trim())} disabled={!isAdd}/>
                                </div>
                            </div>
                            <div className={"modal_item"}>
                                <span className="form_span">
                                    <span style={{color: 'red'}}>*</span>{Strings.rs10155}
                                </span>
                                <div className={"form_value"}>
                                    <InstructTypeSelect value={routine} platform={props.platform} onChange={setRoutine} disabled={!isAdd}/>
                                </div>
                            </div>
                            {/*自定义指令*/}
                            {routine === "0"?<div  className={"modal_item mgb10"}>
                                <span className="form_span"/>
                                <div className={"form_value"}>
                                    <Input value={format}  type={'text'} autoComplete='new-password'
                                           onChange={(e)=>setFormat(e.target.value.trim())}
                                      placeholder={Strings.rs14362 || Strings.input6} maxLength={32} disabled={!isAdd}/>
                                </div>
                            </div>:null}
                            {routine === "0"?<div  className={"modal_item"}>
                                <span className="form_span"/>
                                <div className={"form_value tip"}><span>{Strings.rs14363}</span></div>
                            </div>:null}
                            <div className={"modal_item"}>
                                <span className="form_span">{Tools.isDeviceMgt(props.platform)?Strings.lsTime:Strings.rs10276}</span>
                                <div className={"form_value"}>
                                    <DatePicker value={time ? moment(time, formatTime) : null} disabled={!isAdd}
                                                format={formatTime} allowClear={true}
                                                placeholder={Strings.rs14337}
                                                className="calendar"
                                                onChange={setTime}
                                                showToday={false}
                                                showTime={true}
                                                disabledDate={Tools.handleDisabledBeforeDate}/>
                                </div>
                            </div>
                            {Tools.isDeviceMgt(props.platform)?<div className={"modal_item mgb0"}>
                                <span className="form_span">{Strings.rs14389}</span>
                                <div className={"form_value"}>
                                    <Select value={rules} disabled={!isAdd} onChange={(value)=>{
                                        setRules(value)
                                        setCount(repeatObj[value])
                                    }}>
                                        <Option value={0}>{Strings.rs14365}</Option>
                                        <Option value={1}>{Strings.rs14090}</Option>
                                        <Option value={2}>{Strings.rs14091}</Option>
                                        <Option value={3}>{Strings.rs14366}</Option>
                                    </Select>
                                </div>
                            </div>:null}
                            {Tools.isDeviceMgt(props.platform) && rules? <div className={"modal_item mg_bottom0 mg_top15"}>
                                <span className="form_span">{Strings.rs14390}</span>
                                <div className={"form_value"}>
                                    <Select value={repeatCount} onChange={setRepeatCount} disabled={!isAdd}>
                                        <Option value={0}>{Strings.rs14367}</Option>
                                        <Option value={1}>{Strings.rs14368}</Option>
                                    </Select>
                                </div>
                            </div>:null}
                            {Tools.isDeviceMgt(props.platform) && repeatCount && rules? <div className={"modal_item mg_bottom0 mg_top15"}>
                                <span className="form_span"/>
                                <div className={"form_value"}>
                                  <Input value={count} disabled={!isAdd}
                                         onChange={(e)=>{
                                             let newCount = '';
                                             if(Tools.isNumber(e.target.value) && e.target.value <= repeatObj[rules] && e.target.value >= 1) {
                                                 newCount = Tools.getnum(e.target.value)
                                                 setCount(newCount)
                                             } else {
                                                 setCount('')
                                             }
                                         }}
                                         placeholder={repeatDescObj[rules]}
                                         maxLength={3}/>
                                </div>
                            </div>:null}
                            {Tools.isDeviceMgt(props.platform)?<div className="modal_item bottom_tip mg_top10">
                                {Strings.rs14370}
                            </div>:null}
                            {Tools.isDeviceMgt(props.platform)?null:<div className={"modal_item"}>
                                <span className="form_span">
                                    <span style={{color: 'red'}}>*</span>{Strings.sendtype}
                                </span>
                                <div className={"form_value"}>
                                    <Select className={"w240"} disabled={!isAdd} value={sendType} placeholder={Strings.sendtypeTips} onChange={(value)=>setSendType(value)}>
                                        {Tools.getOptionsFromGlobalEnums("enums.cmdSendType","select")}
                                    </Select>
                                </div>
                            </div>}
                            {Tools.isDeviceMgt(props.platform)?null:emailItems()}
                            {Tools.isDeviceMgt(props.platform)?null:<div className={"modal_item"}>
                                <span className="form_span">{sendType === "1"?<span style={{color: 'red'}}>*</span>:""}{Strings.rs10277}</span>
                                <div className={"form_value"}>
                                    <DatePicker value={deadlineTime ? moment(deadlineTime, formatTime) : null} disabled={!isAdd}
                                                format={formatTime} allowClear={true}
                                                placeholder={Strings.rs14337}
                                                className="calendar"
                                                onChange={setDeadlineTime}
                                                showToday={false}
                                                showTime={true}
                                                disabledDate={Tools.handleDisabledBeforeDate}/>
                                </div>
                            </div>}

                        </div>
                    </div>
                    <div className="btn-row mg_top24">
                        <Button className="mg_right10" onClick={hideModal}>{Strings.rs10054 || Strings.cancel}</Button>
                        <Button type='primary' disabled={(!isAdd&&(status === 0 || status === 2))||Tools.isMonitor()} onClick={handleOk}>{Strings.rs10058 || Strings.sure}</Button>
                    </div>
                    {/*点击确定后，不支持指令的设备清单*/}
                    <Modal transitionName="" maskTransitionName=""
                           className="default_modal wid1000 mic_model"
                           destroyOnClose={true}
                           visible={errorList_visible}
                           onCancel={()=>{setErrorList_visible(false);setErrorList([])}}
                           maskClosable={false}
                           footer={null}>
                        <div>{Strings.notSupport}</div>
                        <WWTable className={"new_app_table"}
                                 columns={error_columns} innerHeight={350} height={0}
                                 dataSource={errorList}  pagination={false} hiddenPagination={true}/>
                    </Modal>
                </Modal>
}

export default forwardRef(AddBatchInstructModalMic)